<p-toast [style]="{width: 'auto'}" position="top-right" key="tc" [baseZIndex]="10000"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmDialog header="Confirmation" key="logOutTimer" [visible]="this.authDialog()" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<router-outlet></router-outlet>